'use strict';

angular.module('sellers')
.directive("item" , function(){
  return {
    template: '<ng-include src="getTemplateUrl()"/></ng-include>'
    ,scope: {
        item: '=data'
    }
    ,restrict: 'E'
    ,replace:true
    ,controller: [ '$scope', function($scope) {

      $scope.getTemplateUrl = function() {
        if ($scope.item.action == "Added")
          return "partials/new.html";
        if ($scope.item.action == "Sold")
          return "partials/sold.html";
      }
    }]
  };
});